<template>
  <div class="h-full flex flex-col justify-center items-center">
    <ShieldExclamationIcon class="h-16 w-16 lg:w-24 lg:h-24 text-red-600" />
    <p class="mt-3 font-medium">{{__('Error connecting to the server!')}}</p>
    <button class="btn btn-primary mt-8 px-6" @click="$emit('tryAgain')">{{__('Try Again')}}</button>
  </div>
</template>
<script setup>
import {ShieldExclamationIcon} from '@heroicons/vue/24/outline';
</script>